import * as React from "react";
import { SmallIcon } from "@utdanningsdirektoratet/icon";
import Link from "./Link";

interface ButtonLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconLeft?: SmallIcon;
  iconRight?: SmallIcon;
  bold?: boolean;
  color?: "darkgrey";
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const ButtonLink: React.FC<ButtonLinkProps> = ({ className, children, bold, color, iconLeft, iconRight, disabled, style, ...rest }) => {
  return (
    <Link
      text={children}
      style={style}
      className={className}
      bold={bold}
      color={color}
      iconLeft={iconLeft}
      iconRight={iconRight}
      disabled={disabled}
    >
      {(props, content) => (
        <button
          {...rest}
          {...props}
          onClick={(event) => {
            if (props.onClick) props.onClick(event);
            if (rest.onClick) rest.onClick(event);
          }}
          disabled={disabled}
          type="button"
          role="link"
        >
          {content}
        </button>
      )}
    </Link>
  );
};

export default ButtonLink;
